export default function AboutPage() {
  return (
    <div className="card">
      <h2>About SiftMyMail</h2>
      <p>
        SiftMyMail is a privacy-first helper that scans your own Gmail mailbox in the browser. Tokens and message data
        never leave your device.
      </p>
      <h3>Privacy promise</h3>
      <ul>
        <li>No ads, no tracking pixels, no analytics.</li>
        <li>Access is read-only and uses the minimum Gmail scope.</li>
        <li>We do not store or transmit message bodies to any server.</li>
      </ul>
      <h3>Developed and maintained by</h3>
      <p>
        SiftMyMail is developed and maintained by Christy and Ryan, LLC, a Texas-based company dedicated to building
        helpful, privacy-respecting tools.
      </p>
      <h3>Our Mission</h3>
      <p>Our mission is to build the products for the world we want to live in.</p>
      <p>
        We believe essential digital tools should be accessible to everyone—especially the elderly and the young—without
        being buried under invasive advertising or exploitative business models. In particular, we believe advertising in
        applications intended for children has gone too far.
      </p>
      <p>
        Christy and Ryan, LLC operates on a donation-supported model. Both founders maintain full-time employment and
        self-fund development when donations are unavailable, because we believe meaningful change starts with personal
        responsibility.
      </p>
      <p>
        Additional applications and services are currently in development. Options to support our work, such as donating
        or sponsoring development time, will be available soon.
      </p>
      <h3>How scoring works</h3>
      <p>
        SiftMyMail uses rule-based checks that look at sender domains, authentication results, suspicious links, and
        urgent language. Each signal has a weight and contributes to a transparent risk score between 0 and 100.
      </p>
      <h3>Support the project</h3>
      <p>
        This project stays free and tracker-free thanks to community support. If SiftMyMail helps you, consider sharing
        feedback or donating to keep it running. (Donation link placeholder)
      </p>
      <p>© 2025 Christy and Ryan, LLC. All rights reserved.</p>
    </div>
  );
}
